import { useState } from "react";

import Lock from "@/assets/icons/lock.svg?react";
import { Button } from "@/components/Button";
import { COMING_SOON } from "@/constants";
import { AchievementsOpenLevelProps } from "@/interfaces/modals";
import { convertNumberToRoman } from "@/utils/convertToRoman";

import styles from "./styles";
import { SheetModal } from "../index";
import { SheetDescription, SheetTitle } from "../styles";

export const useAchievementsModal = () => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const [achievement, setAchievement] = useState<AchievementsOpenLevelProps | null>(null);

  const openModal = (props: AchievementsOpenLevelProps) => {
    setAchievement(props);
    setOpen(true);
  };

  const closeModal = () => {
    setAchievement(null);
    setOpen(false);
  };

  const modal = achievement ? (
    <SheetModal isOpen={isOpen} closeModal={closeModal} detent="content-height">
      <styles.Container>
        <styles.Level $completed={achievement.level.complete} $level={achievement.level.id}>
          <span>{achievement.description === COMING_SOON ? <Lock /> : convertNumberToRoman(achievement.level.id)}</span>
          {achievement.level.icon}
        </styles.Level>
        <SheetTitle>{achievement.title}</SheetTitle>
        <SheetDescription>{achievement.description}</SheetDescription>
        {achievement.action && !achievement.level.complete ? (
          <Button type="black" handler={achievement.action.handler} name={achievement.action.title} />
        ) : (
          <Button type="black" handler={closeModal} name="Ok" />
        )}
      </styles.Container>
    </SheetModal>
  ) : (
    <></>
  );

  return { isOpen, openModal, closeModal, modal };
};
